import { Component } from '@angular/core';

@Component({
    selector: 'app-leaderboard-view',
    templateUrl: 'leaderboard.component.html',
    styleUrls: ['leaderboard.component.scss']
})

export class LeaderboardComponent {
    constructor() {

    }
}